import { t } from 'i18next'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { FileState, isImage, isPDF } from './attaches.type'

type AttacheViewerProps = {
  open: boolean
  setClose: () => void
  file: FileState | null
}

export default function AttacheViewer(props: AttacheViewerProps) {
  const { open, setClose, file } = props

  return (
    <FormLayout //
      title={t('pms.booking.reservation.tab.attaches.preview.title')}
      appearance={{ type: 'DRAWER', open: open, onClose: setClose, large: true }}
      toolbar={
        <FormLayoutDefaultToolbar
          customButtons={[
            {
              text: t('commons.close'),
              clickHandler: setClose,
            },
          ]}
        />
      }
    >
      {file && isPDF(file.type) && <iframe src={`${file.URL}#toolbar=1&view=fitH`} width="100%" height="100%" />}
      {file && isImage(file.type) && <img src={file.URL} width="100%" />}
    </FormLayout>
  )
}
